export default __webpack_public_path__ + "static/media/home.69a956c0.svg";